import axios from 'axios';
import {
  AI_PROMPT_BUILDER_FETCH_PAGES_BEGIN,
  AI_PROMPT_BUILDER_FETCH_PAGES_SUCCESS,
  AI_PROMPT_BUILDER_FETCH_PAGES_FAILURE,
  AI_PROMPT_BUILDER_FETCH_PAGES_DISMISS_ERROR,
} from './constants';

export function fetchPages(args = {}) {
  return (dispatch) => {
    dispatch({
      type: AI_PROMPT_BUILDER_FETCH_PAGES_BEGIN,
    });

    const { version } = args;
    const promise = new Promise((resolve, reject) => {
      const doRequest = axios.post(
        `${process.env.REACT_APP_BUILDER_AI_ENGINE}v${version}/optimal-pages`,
        args,
      );
      doRequest.then(
        (res) => {
          dispatch({
            type: AI_PROMPT_BUILDER_FETCH_PAGES_SUCCESS,
            data: res,
          });
          resolve(res);
        },
        (err) => {
          dispatch({
            type: AI_PROMPT_BUILDER_FETCH_PAGES_FAILURE,
            data: { error: err },
          });
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function dismissFetchPagesError() {
  return {
    type: AI_PROMPT_BUILDER_FETCH_PAGES_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case AI_PROMPT_BUILDER_FETCH_PAGES_BEGIN:
      return {
        ...state,
        fetchPagesPending: true,
        fetchPagesError: null,
      };

    case AI_PROMPT_BUILDER_FETCH_PAGES_SUCCESS:
      return {
        ...state,
        fetchPagesPending: false,
        fetchPagesError: null,
        optimalPages: action.data,
      };

    case AI_PROMPT_BUILDER_FETCH_PAGES_FAILURE:
      return {
        ...state,
        fetchPagesPending: false,
        fetchPagesError: action.data.error,
      };

    case AI_PROMPT_BUILDER_FETCH_PAGES_DISMISS_ERROR:
      return {
        ...state,
        fetchPagesError: null,
      };

    default:
      return state;
  }
}
